<script setup lang="ts">
  import { Spinner } from "@/components/ui/spinner";

  defineProps<{
    text?: string;
  }>();
</script>

<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-overlay flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div class="flex flex-col items-center gap-3">
        <Spinner class="size-8" />
        <p
          v-if="text"
          class="text-sm text-muted-foreground">
          {{ text }}
        </p>
      </div>
    </div>
  </Teleport>
</template>
